<!-- 页面底部公司信息 -->
<template>
	<div class="ourInformation">
		<div class="inforBox" :style="boxSizeWidth">
			<div class="rightERcode" v-if="codeShow == 1 && !smallScreen">
				<div class="codeItem" v-for="item in erCodeList" :key="item.objid">
					<img class="itemImg" :src="item.imageAddress" alt="">
					<div class="itemText">{{ item.title }}</div>
				</div>
			</div>
			<div class="leftText">
				<div class="companyName">{{ enterpriceInfo.name }}</div>
				<div>总部地址： {{ enterpriceInfo.address }}</div>
				<div>服务热线： {{ enterpriceInfo.phone }}</div>
				<div>邮箱地址： {{ enterpriceInfo.email }}</div>
				<div class="middleERcode" v-if="codeShow == 1 && smallScreen">
					<div class="codeItem" v-for="item in erCodeList" :key="item.objid">
						<img class="itemImg" :src="item.imageAddress" alt="">
						<div class="itemText">{{ item.title }}</div>
					</div>
				</div>
				<div v-if="linkShow == 1" style="font-size: 18px; margin-top: 60px;">
					<span style="color: #333333;">友情链接：</span>
					<span class="friends" v-for="item in firendsList" :key="item.objid" @click="outsideClick(item.link_address)">{{ item.title }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'footer-info',
	data() {
		return {
			linkShow:1,
			codeShow:1,
			enterpriceInfo: {},
			firendsList: [],
			erCodeList: [],
			// 移动窄屏适配
			boxSizeWidth: '',
			smallScreen: false,
		};
	},
	mounted() {
		this.getMainPageConfig(),
		this.getEnterpriceInfo();
		this.getLinksList();
		this.getQrcodeList();

		if (document.body.clientWidth < 1200) this.boxSizeWidth = 'width: calc(100% - 60px);';
		else this.boxSizeWidth = 'width: 1200px;';
		
		if (document.body.clientWidth < 660) this.smallScreen = true;
		else this.smallScreen = false;
	},
	methods: {
		// 获取首页配置项
		getMainPageConfig() {
			this.$API.getNavbar({ refgrp: 'OW_NAVI_BAR' }, (res) => {
				let navbarList = res;
				navbarList.forEach((item) => {
					if (item.navi_cd === 'FRIENDSHIP_LINKS') this.linkShow = item.is_enabled;
					if (item.navi_cd === 'QRCORD_LIST') this.codeShow = item.is_enabled;
				});
			});
		},
		getEnterpriceInfo() {
			let infoData = {};
			this.$API.getEnterpriceInfo({}, (res) => {
				infoData.name = res.list[0].company_name;
				infoData.address = res.list[0].address;
				infoData.phone = res.list[0].service_hotline;
				infoData.email = res.list[0].mail_address;
				this.enterpriceInfo = infoData;
			});
		},
		getLinksList() {
			this.$API.getLinksList({}, (res) => {
				this.firendsList = res.list;
			});
		},
		getQrcodeList() {
			this.$API.getQrcodeList({}, (res) => {
				this.erCodeList = res.list;
				for (let item of this.erCodeList) {
					item.imageAddress = process.env.BASE_API + 'mp-file/file/' + item.images[0].image_address;
				}
			});
		},

		// 友情链接点击
		outsideClick(link) {
			if (!link) return;
			window.open(link, '_blank');
		},
	},
	watch: {
	},
};
</script>

<style scoped>
.ourInformation {
	width: 100%;
	/* height: 360px; */
	background-color: #F6F6F6;
}
.inforBox {
	width: 1200px;
	margin: auto;
	padding: 60px 0;
}
.leftText {
	text-align: left;
	line-height: 30px;
	color: #6D6D6D;
}
.companyName {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 20px;
	color: #4C4C4C;
}
.friends {
	cursor: pointer;
	font-size: 16px;
	display: inline-block;
	margin-right: 30px;
}

.rightERcode {
	float: right;
	display: flex;
}
.middleERcode {
	display: flex;
	margin-top: 20px;
	margin-bottom: -30px;
}
.codeItem {
	margin-left: 20px;
}
.itemImg {
	width: 82px;
	height: 82px;
	margin-bottom: 10px;
}
.itemText {
	padding: 6px;
	width: 80px;
	line-height: 24px;
	background-color: #ECF5FF;
}
</style>



// WEBPACK FOOTER //
// src/pageLayout/footerInfo.vue